import { fork } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import chargeSetupIntent from './chargeSetupIntent';
import { CHARGE_SETUP_INTENT } from 'app/constants';


// takeEvery, not takeLatest: a round-trip confirmation page renders one
// Pay Now button per leg (each with its own reservationId), so charging one
// leg must not cancel an in-flight charge for the other. Each button's own
// disabled state already prevents a repeat click on the SAME reservation.
export default function* watchChargeSetupIntent() {
  yield fork(takeEvery, CHARGE_SETUP_INTENT, chargeSetupIntent);
}
